<template>
  <basic-container>
    <el-form ref="searchForm" :model="query" label-width="100px" margin-top="0" :rules="rules">
      <el-col :span="4">
        <el-form-item label="收费员" prop="userName">
          <el-input v-model="query.userName" placeholder="收费员"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="4">
        <el-form-item label="费用类型" prop="cutBank">
          <el-select v-model="query.feeTypeParam" clearable placeholder="全部">
            <el-option
              style="padding-left: 10px;"
              v-for="item in feeTypeParamList"
              :key="item.dictKey"
              :label="item.dictValue"
              :value="item.dictKey"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :span="4">
        <el-form-item label="支付方式" prop="payType">
          <el-select v-model="query.payType" clearable placeholder="全部">
            <el-option
              style="padding-left: 10px;"
              v-for="item in payTypeList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :span="7">
        <el-form-item label="支付时间 从" prop="dateRange">
          <el-date-picker
            v-model="query.dateRange"
            type="daterange"
            value-format="yyyy-MM-dd"
            range-separator="到"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          >
          </el-date-picker>
        </el-form-item>
      </el-col>

      <el-col :span="5">
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="submitSearchForm">搜索</el-button>
          <el-button icon="el-icon-delete" @click="searchReset">清空</el-button>
        </el-form-item>
      </el-col>
    </el-form>
    <avue-crud
      :option="option"
      :table-loading="loading"
      :data="data"
      :page.sync="page"
      :permission="permissionList"
      :before-open="beforeOpen"
      v-model="form"
      ref="crud"
      @row-update="rowUpdate"
      @row-save="rowSave"
      @row-del="rowDel"
      @search-change="searchChange"
      @search-reset="searchReset"
      @selection-change="selectionChange"
      @current-change="currentChange"
      @size-change="sizeChange"
      @on-load="onLoad"
      @refresh-change="onLoad"
    >
    </avue-crud>
  </basic-container>
</template>

<script>
import { getList } from '@/api/v4ward/offlinepay/offLineSum';
import { mapGetters } from 'vuex';
import { getDictionary } from '../../../api/common';

var DIC = {
  PAYTYPE: [
    {
      label: '微信',
      value: 'W',
    },
    {
      label: '支付宝',
      value: 'A',
    },
  ],
};
export default {
  data() {
    return {
      form: {},
      query: {},
      loading: true,
      saveBtn: false,
      showSummary: false,
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      selectionList: [],
      payTypeList: DIC.PAYTYPE,
      feeTypeParamList: [],
      option: {
        height: 'auto',
        calcHeight: 350,
        tip: false,
        border: true,
        index: true,
        indexLabel: '序号',
        viewBtn: true,
        menu: false,
        selection: true,
        column: [
          {
            label: '订单号',
            minWidth: 150,
            prop: 'orderNo',
          },
          {
            label: '收费员',
            prop: 'userName',
          },
          {
            label: '费用类型参数',
            prop: 'feeTypeParam',
            hide: true,
          },
          {
            label: '费用类型',
            prop: 'feeTypeValue',
          },
          {
            label: '支付方式',
            prop: 'payType',
            type: 'select',
            dicData: DIC.PAYTYPE,
          },
          {
            label: '收费金额',
            prop: 'payMoney',
          },
          {
            label: '收费时间',
            prop: 'payTime',
          },
        ],
      },
      data: [],
    };
  },

  computed: {
    ...mapGetters(['permission']),
    permissionList() {
      return {
        addBtn: this.vaildData(this.permission.offlineSum_add, false),
        viewBtn: this.vaildData(this.permission.offlineSum_view, false),
        delBtn: this.vaildData(this.permission.offlineSum_delete, false),
        editBtn: this.vaildData(this.permission.offlineSum_edit, false),
      };
    },
    ids() {
      let ids = [];
      this.selectionList.forEach((ele) => {
        ids.push(ele.id);
      });
      return ids.join(',');
    },
  },
  created() {
    this.initFeeTypeParamList();
  },
  methods: {
    initFeeTypeParamList() {
      getDictionary('offline_fee_type').then((data) => {
        this.feeTypeParamList = data.data;
      });
    },
    rowSave(row, loading, done) {
      add(row).then(
        () => {
          loading();
          this.onLoad();
          this.$message.success('操作成功!');
        },
        (error) => {
          done();
          console.log(error);
        }
      );
    },
    rowUpdate(row, index, loading, done) {
      update(row).then(
        () => {
          loading();
          this.onLoad();
          this.$message.success('操作成功!');
        },
        (error) => {
          done();
          console.log(error);
        }
      );
    },
    rowDel(row) {
      this.$confirm('确定将选择数据删除?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          return remove({ ids: row.id });
        })
        .then(() => {
          this.onLoad();
          this.$message.success('操作成功!');
        });
    },
    submitSearchForm() {
      this.searchChange(this.query);
    },
    handleDelete() {
      if (this.selectionList.length === 0) {
        this.$message.warning('请选择至少一条数据');
        return;
      }
      this.$confirm('确定将选择数据删除?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          return remove({ ids: this.ids });
        })
        .then(() => {
          this.onLoad();
          this.$message.success('操作成功!');
          this.$refs.crud.toggleSelection();
        });
    },
    beforeOpen(done, type) {
      if (['edit', 'view'].includes(type)) {
        getDetail({ id: this.form.id }).then(({ data }) => {
          this.form = data;
        });
      }
      done();
    },
    searchReset() {
      this.query = {};
      this.onLoad();
    },
    searchChange(params, done) {
      this.query = params;
      this.page.currentPage = 1;
      this.onLoad(this.page, params);
    },
    selectionChange(list) {
      this.selectionList = list;
    },
    selectionClear() {
      this.selectionList = [];
      this.$refs.crud.toggleSelection();
    },
    currentChange(currentPage) {
      this.page.currentPage = currentPage;
    },
    sizeChange(pageSize) {
      this.page.pageSize = pageSize;
    },
    onLoad(page, params = {}) {
      page = page || this.page;
      if (params.dateRange) {
        params.payTimeStart = params.dateRange[0];
        params.payTimeEnd = params.dateRange[1];
      }
      this.loading = true;
      getList(Object.assign({ current: page.currentPage, size: page.pageSize }, this.query)).then(
        ({ data }) => {
          this.page.total = data.total;
          this.data = data.records;
          this.loading = false;
          this.selectionClear();
        }
      );
    },
  },
};
</script>

<style></style>
